import React, { useState } from 'react';
import { Tabs } from '@forgeglobal/design-framework';
import TabContent from '@tcs/common/components/atoms/TabContent';
import Header from '@tcs/client-portal-common/components/organisms/Header';
import ProfileSecurity from '@tcs/client-portal-common/components/templates/ProfileSecurity';
import PasswordSuccessBanner from '@tcs/client-portal-common/components/molecules/PasswordSuccessBanner';
import { useGetQuestion } from '@tcs/client-portal-common/hooks/auth';
import { Route } from 'react-router';

const Profile = () => {
  const { data: securityQuestion, loading } = useGetQuestion();
  const [showMessage, setShowMessage] = useState('');
  const [question, setQuestion] = useState('');

  return (
    <>
      <PasswordSuccessBanner
        message={showMessage}
        dismissMessage={() => setShowMessage('')}
      />
      <Header
        pageTitle="Profile"
        tabs={() => (
          <Tabs>
            <Route
              path="*"
              element={
                <TabContent
                  label="Security"
                  data-test-id="profile-security-tab">
                  <ProfileSecurity
                    question={question || securityQuestion?.text}
                    setQuestion={setQuestion}
                    showMessage={setShowMessage}
                    loading={loading}
                  />
                </TabContent>
              }
            />
          </Tabs>
        )}
      />
    </>
  );
};

export default Profile;
